<template>
  <div class="page-chatroom" v-loading="uploadLoading" >

    <div class="chat-wrap" id="htmlArea">
      <div class="chat-head">
        <div class="side-r clearfix">
          <router-link class="firend-info clearfix" to="">
            <div class="avatar" :style="{'background-image': 'url(' + user.face + ')'}"></div>
            <span class="name">{{user.name}}</span>
          </router-link>

          <el-dropdown class="serve-state" @command="handelUserState" v-if="currentUserId==csId">
            <span class="el-dropdown-link">
              <i
                class="el-icon-phone sta-point"
                :class="{'online': userState === 0, 'offline': userState === 1, 'busy': userState === 2}"
              >
              </i>
              {{userState === 0 ? '在线' : userState === 1 ? '离线' : '忙碌'}}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown" >
              <el-dropdown-item command="0">在线</el-dropdown-item>
              <el-dropdown-item command="1">离线</el-dropdown-item>
              <el-dropdown-item command="2">忙碌</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <div class="shu"></div>
          <router-link class="setting" to="/setting">
            <i class="el-icon-setting"></i>
          </router-link>
        </div>
      </div>
      <div class="list-chat clearfix">
        <div class="left-list">
          <div class="info-chat-one clearfix">

          </div>
          <div @click="selectUser(item)" :class="item.userId == receiveUserId ? 'firend-item clearfix active' : 'firend-item clearfix'"  v-for="(item,index) in userList" :key="index">
            <div class="info-chat-one clearfix">
              <div class="avatar" :style="{'background-image': 'url(' + item.avatar + ')'}"></div>
              <div class="chat-one">
                <span class="name over">{{item.userName}}</span>
                <span class="one over">{{item.lastMessage}}</span>
              </div>
            </div>
            <!--            <div class="time">{{item.lastMessageTime}}</div>-->
          </div>

        </div>
        <div class="right-chat">
          <div class="show-infoo clearfix">
            <div class="his-name" v-if="receiveUserId==csId">
              {{receiveUserInfo.userName}}
              <i class="el-icon-more sta-point online" v-if="userState==0"></i>
              <i class="el-icon-more sta-point offline" v-if="userState==1"></i>
              <i class="el-icon-more sta-point busy" v-if="userState==2"></i>
            </div>
            <div class="his-name" v-if="receiveUserId!=csId">
              {{receiveUserInfo.userName}}
            </div>
            <div class="cz-his" v-if="receiveUserId">
              <el-dropdown @command="setTop">
                <span class="el-dropdown-link">
                  <i class="el-icon-more"></i>
                </span>
                <el-dropdown-menu slot="dropdown" >
                  <el-dropdown-item command="0" v-if="istop===0" >置顶</el-dropdown-item>
                  <el-dropdown-item command="1" v-if="istop===1" >取消置顶</el-dropdown-item>
                  <el-dropdown-item command="2" >移入黑名单</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div class="chizi" id="rightContent"  ref="rightContent" @scroll="scrollEvent">
            <div class="clearfix" v-if="hasMore==1">
              <div class="words add-more" @click="geMoreMessage"><i class="el-icon-loading" v-if="loading"></i> 点击加载更多</div>
            </div>
            <div class="clearfix" v-if="hasMore==0">
              <div class="words no-more">没有更多了</div>
            </div>
            <div  v-for="(item,index) in messageList" :key="index">
              <div class="show-time"><span>{{item.time}}</span></div>

              <div class="other clearfix" v-if="item.userid==receiveUserId && item.type=='str'">
                <div class="avatar" :style="{'background-image': 'url(' + item.face + ')'}"></div>
                <div class="words" v-html="item.content.replace(/\#[\u4E00-\u9FA5]{1,3}\;/gi, emotion)"></div>
              </div>

              <div class="myself clearfix" v-if="item.userid==currentUserId && item.type=='str'">
                <div class="avatar" :style="{'background-image': 'url(' + item.face + ')'}"></div>
                <div class="words" v-html="item.content.replace(/\#[\u4E00-\u9FA5]{1,3}\;/gi, emotion)"></div>
              </div>

              <div class="other clearfix" v-if="item.userid==receiveUserId && item.type=='file'">
                <div class="avatar" :style="{'background-image': 'url(' + item.face + ')'}"></div>
                <div class="words type-file">
                  <img class="left-type-icon" :src="require('@/assets/images/type_icon.png')" alt="">
                  <a :href="item.content.url" class="file-info">
                    <div class="tit">{{item.content.originalFileName}}</div>
                    <div class="size">{{item.content.filesizeM}}</div>
                  </a>
                </div>
              </div>
              <div class="myself clearfix" v-if="item.userid==currentUserId && item.type=='file'">
                <div class="avatar" :style="{'background-image': 'url(' + item.face + ')'}"></div>
                <div class="words type-file">
                  <img class="left-type-icon" :src="require('@/assets/images/type_icon.png')" alt="">
                  <a :href="item.content.url" class="file-info">
                    <div class="tit">{{item.content.originalFileName}}</div>
                    <div class="size">{{item.content.filesizeM}}</div>
                  </a>
                </div>
              </div>
              <div class="other clearfix" v-if="item.userid==receiveUserId && item.type=='image'">
                <div class="avatar" :style="{'background-image': 'url(' + item.face + ')'}"></div>
                <div class="words type-img">
                  <vue-viewer
                    :thumb="item.content"
                    :full="item.content"
                  >
                  </vue-viewer>
                </div>
              </div>
              <div class="myself clearfix" v-if="item.userid==currentUserId && item.type=='image'">
                <div class="avatar" :style="{'background-image': 'url(' + item.face + ')'}"></div>
                <div class="words type-img">
                  <vue-viewer
                    :thumb="item.content"
                    :full="item.content"
                  >
                  </vue-viewer>
                </div>
              </div>
<!--              <div class="other clearfix" >-->
<!--                <div class="avatar" :style="{'background-image': 'url(' + require('@/assets/images/user_avatar.jpg') + ')'}"></div>-->
<!--                <div class="words type-video" @click="showVideoEvent">-->
<!--                  <img :src="require('@/assets/images/rrdh_bg_moxing.jpg')" alt="">-->
<!--                  <i class="play-icon"></i>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="myself clearfix">-->
<!--                <div class="avatar" :style="{'background-image': 'url(' + require('@/assets/images/user_avatar.jpg') + ')'}"></div>-->
<!--                <div class="words type-video" @click="showVideoEvent">-->
<!--                  <img :src="require('@/assets/images/rrdh_bg_moxing.jpg')" alt="">-->
<!--                  <i class="play-icon"></i>-->
<!--                </div>-->
<!--              </div>-->

            </div>
          </div>
          <div class="cons">
            <div class="btns clearfix">
              <!-- 表情 -->
              <div class="btn-item bq-item">
                <i class="bq" title="表情"></i>
                <div class="emoji-wrap">
                  <emotion class="emoji-list" @emotion="handleEmotion" ></emotion>
                </div>
              </div>
              <!-- 文件 -->
              <div class="btn-item">
                <el-upload
                        action=""
                        :http-request="uploadFile"
                        :before-upload="beforeFileUpload"
                        :on-success="handleSuccess"
                        :show-file-list="false"
                >
                  <i class="wj" title="文件"></i>
                </el-upload>
              </div>
              <!-- 图片 -->
              <div class="btn-item">
                <el-upload
                        action=""
                        :http-request="uploadImg"
                        accept="image/jpeg,image/gif,image/png"
                        :before-upload="beforeImgUpload"
                        :show-file-list="false"
                >
                  <i class="tp" title="图片"></i>
                </el-upload>
              </div>
              <!-- 视频 -->
<!--              <div class="btn-item">-->
<!--                <el-upload-->
<!--                        action="https://jsonplaceholder.typicode.com/posts/"-->
<!--                >-->
<!--                  <i for="upload_file_ipt" class="sp" title="视频"></i>-->
<!--                </el-upload>-->
<!--              </div>-->
<!--              <div id="fileupload" class="btn-item">-->
<!--                <input type="file"  name="files" id="upload_file_ipt" />-->
<!--                <label for="upload_file_ipt" class="upload-btn">视频文件</label>-->
<!--              </div>-->
              <div id="fileupload" class="btn-item">
                <input type="file"  name="files" id="upload_file_ipt" />
                <label for="upload_file_ipt"><i class="sp" title="视频"></i></label>
              </div>
              <!-- 截图 -->
              <div class="btn-item" @click="showUploadImg">
                <i class="jp" title="截图"></i>
              </div>
            </div>
            <div class="myself-input">
              <el-input
                      type="textarea"
                      placeholder="请输入内容"
                      v-model="textarea"
                      resize="none"
              >
              </el-input>
            </div>
            <div class="send-btn clearfix">
              <div class="btn" :class="{active: textarea}" @click="sendMessage">发 送</div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <!-- 上传视频弹窗 -->
    <el-dialog
            title="上传进度"
            :visible.sync="dialogUploadVideo"
            top="100px"
            width="600px"
            :modal-append-to-body="false"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            @close="closeVideoDialog"
            :show-close ="false"
    >
      <!--      :width="$store.state.app.device === 'desktop' ? '600px' : '90%'"-->

      <div class="upload-video">
        <div class="pro">
          <el-progress class="video-progress"  :stroke-width="20" :percentage="processLenghth"></el-progress>
          <div class="text-tit">{{form.videoName}}</div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer cut-image">
<!--            <el-button type="primary" icon="el-icon-video-play" title="继续" style="display: none" class="resumeObj"  v-if="processLenghth!=100"></el-button>-->
<!--            <el-button type="primary" icon="el-icon-video-pause" title="暂停"  class="pauseObj"  v-if="processLenghth!=100"></el-button>-->
<!--            <el-button type="primary" icon="el-icon-close" title="取消" class="cancelOjb" @click="closeVideoDialog"  v-if="processLenghth!=100"></el-button>-->
            <el-button type="primary" icon="el-icon-check" title="确定" @click="finishedUploadVideo" v-if="processLenghth==100"></el-button>
          </span>

    </el-dialog>

    <!-- 上传文件弹窗 -->
    <el-dialog
            title="上传进度"
            :visible.sync="showProgress"
            top="100px"
            width="600px"
            :modal-append-to-body="false"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            @close="cancelUploadFile"
            :show-close ="false"
    >

      <div class="upload-video">
        <div class="pro">
          <el-progress class="video-progress"  :stroke-width="20" :percentage="progress"></el-progress>
          <div class="text-tit">{{uploadFilename}}</div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer cut-image">
            <el-button type="primary" icon="el-icon-check" title="确定" @click="finishedUploadFile" v-if="progress==100"></el-button>
          </span>

    </el-dialog>
    <el-dialog
            title="截图"
            :visible.sync="dialogUploadImg"
            top="10px"
            :closeOnClickModal="false"
            width="70%"
            :modal-append-to-body="false"
    >
      <!--      :width="$store.state.app.device === 'desktop' ? '600px' : '90%'"-->
      <div class="cut-img">
        <div class="cropper-wrap-f">
          <div class="cropper-wrap">
            <vue-cropper
                    ref="cropper"
                    :img="imgOption.img"
                    :fixed="imgOption.fixed"
                    :autoCrop="imgOption.autoCrop"
                    :autoCropWidth="imgOption.autoCropWidth"
                    :autoCropHeight="imgOption.autoCropHeight"
                    :outputType="imgOption.outputType"
                    :fixed-number="imgOption.fixedNumber"
                    mode="cover"
            >
            </vue-cropper>
          </div>
        </div>
<!--        <div class="btns">-->
<!--          <label class="btn"><input type="file" id="uploads" style="position:absolute; clip:rect(0 0 0 0);" accept="image/png, image/jpeg, image/gif, image/jpg" @change="uploadImgNew($event)">{{imgOption.img === '' ? '选择' : '重新选择'}}图片</label>-->
<!--        </div>-->
      </div>
      <span slot="footer" class="dialog-footer cut-image">
        <el-button type="info" @click="hideUploadImg" style="margin-right: 10px"><i class="el-icon-refresh-left"></i> 返回</el-button>
        <el-button type="primary" @click="cutOver"><i class="el-icon-finished"></i> 确定</el-button>
      </span>
    </el-dialog>
<!--    <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">-->
<!--      <div class="show-video" v-if="showVideo">-->
<!--        <div class="mask"></div>-->
<!--        <div class="video-wrap">-->
<!--          <video-player-->
<!--            class="v-video renren-video-player vjs-custom-skin"-->
<!--            :playsinline="true"-->
<!--            :options="playerOptions"-->
<!--          >-->
<!--          </video-player>-->
<!--          <div class="close-video-show" @click="hideVideoEvent"><i class="el-icon-close"></i></div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </transition>-->
  </div>

</template>

<script type="text/ecmascript-6">
  import vueViewer from '@@/pub/viewer/viewer'
  //import "../../../static/css/animate.min.css"
  import Emotion from './Emotion/index'
  //import VueSocketio from 'vue-socket.io';
  import vue from 'vue';
  vue.prototype.$axios = axios;
  import qs from 'qs';
  vue.prototype.qs = qs;
  import axios from "axios";
  import homeApi from '@/api/home'
  import Moment from 'moment'
  import utilAPi from '@/api/util'
  import global_ from '@/api/global'
  import $ from "jquery"
  //import QRCode from 'qrcodejs2'
  // import html2canvas from 'html2canvas'
  // eslint-disable-next-line no-unused-vars
  // import {cch5upload} from '@/utils/cch5/cch5upload'
 // import {VueCropper} from "vue-cropper";
  import { client , getFileNameUUID  } from "@/utils/ali-oss"; //前面的ali-js文件内的两个封装函数

  import updateTdk from "@/utils/tdk";
  import Vue from "vue";
  export default {
    components: {
      Emotion,
      vueViewer,
     // VueCropper,
    },
    inject:['reload'],
    data () {
      return {
        headTitle: "title---rrdh",
        headKeywords: "keywords---rrdh",
        headDesc: "description---rrdh",
        isMounted:false,
        isConn:false,
       options: {
          // https://github.com/simple-uploader/Uploader/tree/develop/samples/Node.js
          target: 'http://www.renrendonghua.com/rrbi/upload/chunk',
          testChunks: true, //上传前判断块是否已经存在
          simultaneousUploads: 1, //并发数
          chunkSize: 1 * 1024 * 1024 //块大小
        },
        attrs: {
          accept: 'image/*'
        },
        showProgress:false,
        progress:0,
        dialogUploadImg:false,
        dialogUploadVideo: false,
        processLenghth:0,
        csId:global_.csId,
        loading:false,
        uploadLoading:false,
        newMessage:{},
        currentUserInfo:{},//当前登录人
        receiveUserInfo:{},//接受人
        messageList:[],//消息内容列表
        textarea: '',//发送的消息
        userList:[],//左侧用户列表
        userImageUrl:"",
        receiveUserId:null,
        currentUserId:null,
        chatLogs:[],
        leftUserIds:[],
        page:1,
        maxPage:1,
        hasMore:0,
        istop:0,
        imgOption: {
          img: '', // require('../../user/setavatar/cropper.jpg')
          fixed: true, // 是否开启截图框宽高固定比例
          fixedNumber: [11, 7], // 截图框比例
          autoCrop: true, // 是否显示截图框
          autoCropWidth: 500, // 截图框默认宽度
          autoCropHeight: 318, // 截图框默认高度
          outputType: 'png' // 图片输出格式
        },
        user: { //当前用户信息
          id:null,
          name: "",
          equipment: '',
          browser:"",
          browserVersion:"",
          workshop_id: null,
          activity_id: null,
          course_id:null,
          //url: location.href,
          group_type:null,
          face: '',
          status:0
        },
        form:{},
        message:{
          "userid": null,
          "username": "",
          "receiveid": null,
          "receivename": "",
          "type": "",
          "createtime": "",
          "time": "",
          "content": ""
        },
        playerOptions : {
          playbackRates: [], //播放速度
          autoplay: false, //如果true,浏览器准备好时开始回放。
          muted: false, // 默认情况下将会消除任何音频。
          loop: false, // 导致视频一结束就重新开始。
          preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
          language: 'zh-CN',
          aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
          fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
          sources: [{
            type: "",
            src: 'http://sunjinyu.cn/images/videobg.mp4'//url地址
            // https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm
          }],
          poster: "http://ocs.21teacher.com/dir-image/2020/3/25/e6381bfb1533469999d2b34ddd548236.jpg", //你的封面地址
          // width: document.documentElement.clientWidth,
          notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
          controlBar: {
            volumePanel: false, // 喇叭 __有bug
            timeDivider: false, // 斜杠 __有bug
            currentTimeDisplay: false, // 当前播放时间
            durationDisplay: false, // 最大时长
            // remainingTimeDisplay: false, //倒计时
          }
        },
        showVideo: false,
        userState: 0,
        fileInfo:{},
        uploadFilename:"",
      }
    },
    created() {
    },


    computed: {
      //...mapState(["indexPage"])
    },
    tdk() {
      return {
        title: this.headTitle,
        description: this.headDesc,
        keywords: this.headKeywords,
        ssrHeadAddInfo: `<link rel="canonical" href="http://www.renrendonghua.com">`
      };
    },
    serverPrefetch() {
      this.setSeo();
      updateTdk.call(this);
      return true
    },

    beforeMount(){
      let thiss =this
      const VueCropperBak = () => import("vue-cropper")
      VueCropperBak().then(res =>{
        thiss.$options.components.VueCropper = res.default.VueCropper
      })

      const html2 = () => import('html2canvas')
      html2().then(res =>{
        Vue.prototype.html2canvas = res.default
      })
      const cch5upload = () => import("@/utils/cch5/cch5upload")

      let this_ = this
      cch5upload().then(res =>{
        var uploader = CCH5Uploader({
          timeout : 180000, // 设置超时处理时间 超时时间3分钟 超时会重试
          maxChunkSize : 1024 * 1024, // 1M 最大不超过4M
          limitConcurrentUploads : 3, //并发上传文件数
          createInfoRetries:5,//调用用户创建视频信息接口重试次数,默认为5次
          maxRetries : 1, // 文件上传失败重试次数,默认10次
          retryTimeout : 500, //重试延迟时间（毫秒）
          autoUpload : true, //是否添加文件后自动上传
          fileInput :  $("#fileupload").find("input[type='file']"), //文件输入组件，必需要有的配置,可以是多个
          filesContainer : $('.videoFiles'), //上传文件记录显示的容器


          //上传失败重试指定次数后依然失败后的回调
          uploadFail : function(recordNode, fileName, failMsg) {
            console.log(failMsg);

            this_.stopUploadVideo()
          },
          progressStatus:function(status){
            this_.processLenghth = status
          },

          //上传成功回调,可不做任何处理
          //微信上传修改成功处理方法，后续需要用到，需要重写
          uploadSuccess : function(recordNode, fileName, ccvid,size) {
            //
            this_.form.videoCcId = ccvid
            this_.form.videoName = fileName

            this_.form.productionVideo = ccvid

            this_.form.videoCcSize = size
            this_.form.videoCcExt =fileName.substring(fileName.indexOf(".")+1,fileName.length)
            this_.form.videoCcName = fileName

          },

          // 生成视频信息
          createuploadinfo: function(fileName, fileSize){
            const isLt200M = fileSize / 1000 / 1000 < 200
            if (!isLt200M) {
              this_.$message.error('上传视频大小不能超过 200MB!')
              return false;
            }

            // else if(this_.form.productionVideo!=''){
            //   this_.$message.error('只能上传一个视频!')
            //   return false;
            // }
            else{
              if(this_.receiveUserId==null||this_.receiveUserId==undefined){
                this_.$message.error("请选择消息发送人")
                return false;
              }
              this_.form.videoName=fileName;
              this_.dialogUploadVideo = true
            }

            let video = {};

            var d = {
              "title" : fileName,
              "filename" : fileName,
              "filesize" : fileSize,
              "notifyurl" :"http://www.renrendonghua.com/rrbi/atta/video/callback",
            };

            $.ajax({
              url : "http://cclive.21teacher.com/ccvideo/uploadVideofront",
              async : false, //必须以同步的方式执行，否则后续操作拿不到接口返回的数据
              type : "post",
              data : d,
              cache : false,
              dataType : "json",
              contentType : "application/x-www-form-urlencoded; charset=UTF-8",
              error : function() {
                video = {
                  "errMsg" : "获取视频文件vid出错",
                  "errorType" : "network"
                };
              },
              success : function(data) {
                if(data.errMsg){
                  video.errMsg = "获取视频文件vid出错";
                  return;
                }
                video.success = true;
                video.uid = data.videoUploadInfo.userid;
                video.ccvid = data.videoUploadInfo.videoid;
                video.servicetype = data.videoUploadInfo.servicetype;
                video.name = fileName;
                video.uri = data.videoUploadInfo.chunkurl;
                video.metauri = data.videoUploadInfo.metaurl;
                video.size = fileSize;

                this_.form.videoCcId = data.videoUploadInfo.videoid

                this_.uploadchunk = data.videoUploadInfo.chunkurl+"?ccvid="+data.videoUploadInfo.videoid;
              }
            });
            return video;
          }
        });
      })


    },

    mounted() {
      this.isMounted = true;

      let this_  = this
      this.checkLogin();

      // var aaa = setInterval(function(){
      //   console.log("isConn================",this_.isConn)
      //   if(this_.global.userModel){
      //     clearInterval(aaa)
      //     //this_.reload();
      //   }
      //   }, 1);
      //
// eslint-disable-next-line no-undef

    },
    sockets:{
      // connection事件回调
      connect: function(data) {
        console.log("===sockets====connect===")
        this.isConn = true
      },
      disconnect:function(){
        this.$socket.emit('connection',1);
      },
      reconnect:function(){
        this.$socket.emit('connection',1);
      },
      newMsg: function(data) {
        console.log("newMsg=========================")
        this.newMessage=data;
        this.$socket.emit('getChatLog', this.user);
        if(this.receiveUserId!=this.newMessage.userid){
          this.$socket.emit('readMsg',this.user.id,this.receiveUserId,"one");
          return ;
        }
        data.face="http://iss.21teacher.com/avatar/125/"+data.userid+"/20.jpg"
        data.type="str";
        if(data.content.indexOf("http://ocs.21teacher.com/dir-image")!=-1||data.content.indexOf("data:image/png;base64")!=-1){
          data.type="image"
        }else if(data.content.indexOf("dir-document")!=-1||data.content.indexOf("aliyuncs.com")!=-1){
            data.type="file"
            data.content=qs.parse(data.content)
            // qs.parse(_this.textarea)
        }
        this.messageList.push(data)


        setTimeout(()=>{
          let div = document.getElementById('rightContent');
          div.scrollTop = div.scrollHeight; },1000)
      },
      imUser:function(data){
        this.userState=data.loginstatus
      },
      msgLog:function(data){
        let that=this
        that.maxPage=data[2]
        if(data[0].length>0){
          if(that.page!=1){
            data[0].reverse();
          }
          data[0].forEach(function (e) {
            e.face="http://iss.21teacher.com/avatar/125/"+e.userid+"/20.jpg";
            e.type="str";
            if(e.content.indexOf("http://ocs.21teacher.com/dir-image")!=-1||e.content.indexOf("data:image/png;base64")!=-1){
                e.type="image"
            }else if(e.content.indexOf("dir-document")!=-1||e.content.indexOf("aliyuncs.com")!=-1){
                e.type="file"
                e.content=qs.parse(e.content)
                // qs.parse(_this.textarea)
            }
            if(that.page==1){
              that.messageList.push(e)
            }else{
              that.messageList.unshift(e)
            }

          })
          that.loading=false;
          if(that.page<that.maxPage){
            that.hasMore=1;

          }else{
            that.hasMore=0;
          }
          if(that.page==1){
            setTimeout(()=>{
              let div = document.getElementById('rightContent');
              div.scrollTop = div.scrollHeight; },1000)
          }
        }else{
          that.loading=false;
          that.hasMore=0;
        }
      },

      emitChatLog: function (data) {
        let that=this
        that.chatLogs=data.data;
        that.leftUserIds=[];
        if(data.data.length>0){
          data.data.forEach(function (item) {
              that.leftUserIds.push(item.friendid)
          })
          if(that.receiveUserId!=null) {
            let isExist = 0
            that.leftUserIds.forEach(function (i) {
              if (i == that.receiveUserId) {
                isExist = 1;
              }
            })
            if (isExist == 0) {
              that.leftUserIds.push(that.receiveUserId)
            }
          }
        }else{
          if(that.receiveUserId!=null){
              that.leftUserIds.push(that.receiveUserId)
          }
        }
        that.getLeftUserList();
      }
    },
    methods:{
      aaa(){
        this.reload()
      },
      setSeo(){
        this.headTitle = "聊天室——人人动画网【官网】";
        this.headKeywords = "聊天室——人人动画网【官网";
        this.headDesc ="聊天室——人人动画网【官网";
      },

      geMoreMessage(){
        this.loading=true;
        this.page=this.page+1
        this.$socket.emit('msgLog', this.currentUserId,this.receiveUserId,this.page);
      },
      scrollEvent(e){
        //滚动加载问题太多，暂时先不用了
        // if(e.target.scrollTop==0){
        //     console.log(this.page)
        //     if(this.page<this.maxPage){
        //         this.page=this.page+1
        //         this.$socket.emit('msgLog', this.currentUserId,this.receiveUserId,this.page);
        //     }
        // }
      },
      initSocket(){
        // this.$socket.emit('login', this.user);
        setTimeout(()=> {
          this.$socket.emit('getChatLog', this.user);
          //获取客服信息
          this.$socket.emit('imUser', global_.csId);
        },2000)

      },
      getReceiveUser(){
        let that=this;
        that.page=1;
        that.messageList=[];
        homeApi.getUserInfo(this.receiveUserId).then(data => {
          if (data.code!=-1) {
            that.userImageUrl="http://iss.21teacher.com/avatar/125/"+that.receiveUserId+"/20.jpg"
            that.receiveUserInfo = data.response
            that.$socket.emit('msgLog', that.currentUserId,that.receiveUserId,1);
            that.$socket.emit('readMsg',that.currentUserId,that.receiveUserId,"one");
            that.userList.forEach(function (e) {
                if(e.userId==that.receiveUserId){
                  e.lastMessage=null;
                }
            })
            that.chatLogs.forEach(function (e) {
              if(e.friendid==that.receiveUserId){
                that.receiveUserInfo.istop=e.istop
                that.istop=e.istop
              }
            })
          }else{
              that.receiveUserId=null;
          }
        })

      },
      checkLogin(){
        let that=this;
        let url='/api/checkLogin?time='+new Date().getMilliseconds();
        that.$axios.get(url).then(function(result){
          if(result.data.isLogin){
            that.currentUserInfo=result.data.casFastUserModel
            that.user.id=that.currentUserInfo.id
            that.currentUserId=that.currentUserInfo.id
            that.user.name=that.currentUserInfo.name
            that.user.face="http://iss.21teacher.com/avatar/125/"+that.currentUserInfo.id+"/20.jpg"
            that.initSocket();
            if(that.$route.query.id!=null&&that.$route.query.id!=undefined){
              that.receiveUserId=that.$route.query.id
                  that.getReceiveUser()
            }else{
              // that.receiveUserId=42866
              // that.getReceiveUser()
            }
          }else{
            that.$router.push({
              path: '/login?callback='+window.location.href,
            })
          }

        })
      },
      getLeftUserList(){
        let url="/rrbi/webim/getLeftUserList?tem="+new Date().getMilliseconds();
        let that=this;
        that.userList=[];
        let si=this.leftUserIds
        // let si=[41482,41483,41484]
        let permission = si.join(",")
        let ids={
          'ids':permission
        }
        that.$axios.post(url,qs.stringify(ids)).then(function (result) {
          if(result.data.response.length>0){
            result.data.response.forEach(function (item) {
              let user={};
              user.userId=item.userId;
              user.userName=item.userName;
              user.avatar="http://iss.21teacher.com/avatar/125/"+item.userId+"/20.jpg"
                that.chatLogs.forEach(function (e) {
                  if(e.friendid==item.userId&&e.lastMessage!=null){
                    user.lastMessage=e.lastMessage;
                  }
                })
              that.userList.push(user)
            })
          }
        })
      },
      sendMessage(){

        let that=this;
        if(that.textarea.trim()==null||that.textarea.trim()==undefined||that.textarea.trim()==""){
          this.$message.error("请先输入消息")
          return;
        }
        if(this.receiveUserId==null||this.receiveUserId==undefined){
            this.$message.error("请选择消息发送人")
            return;
        }
        let url = "/rrbi/friends/getFriendStatus?userId="+this.receiveUserInfo.userId+"&currentUserId="+this.currentUserInfo.id+"&tem="+new Date().getMilliseconds()
        this.$axios.get(url).then(function (result) {
          if(that.currentUserInfo.id==global_.csId||that.receiveUserInfo.userId==global_.csId||result.data==2){
            that.message={};
            that.message.userid=that.currentUserInfo.id
            that.message.username=that.currentUserInfo.name
            that.message.receiveid=that.receiveUserInfo.userId
            that.message.receivename=that.receiveUserInfo.userName
            that.message.type="one"
            that.message.time=Moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
            that.message.createtime=new Date()
            that.message.content=that.textarea
            that.message.face="http://iss.21teacher.com/avatar/125/"+that.currentUserInfo.id+"/20.jpg"
            that.$socket.emit('postMsg',that.message)
            that.message.type="str";
            if(that.message.content.indexOf("http://ocs.21teacher.com/dir-image")!=-1||that.message.content.indexOf("data:image/png;base64")!=-1){
              that.message.type="image"
            }else if(that.message.content.indexOf("dir-document")!=-1||that.message.content.indexOf("aliyuncs.com")!=-1){
              that.message.type="file"
                that.message.content=qs.parse(that.message.content)
            }
            that.messageList.push(that.message)
            that.textarea="";
            setTimeout(()=>{
              let div = document.getElementById('rightContent');
              //客服不是在线状态
              if(that.receiveUserId==global_.csId&&that.userState!=0){
                let message={}
                message.userid=that.receiveUserInfo.userId
                message.username=that.receiveUserInfo.userName
                message.receiveid=that.currentUserInfo.id
                message.receivename=that.currentUserInfo.name
                message.type="one"
                message.time=Moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
                message.createtime=new Date()
                message.content="这会不在线，有事给我留言"
                message.face="http://iss.21teacher.com/avatar/125/"+that.receiveUserInfo.userId+"/20.jpg"
                message.type="str";
                that.messageList.push(message)
              }
              div.scrollTop = div.scrollHeight; },1000)
          }else{
            that.$message.error('你与对方不是好友关系，无法发送消息!')
          }

        })


      },
      selectUser(user){
        this.receiveUserId=user.userId
        this.getReceiveUser();
        this.page=1;
      },
      beforeImgUpload (file) {
        if(this.receiveUserId==null||this.receiveUserId==undefined){
          this.$message.error("请选择消息发送人")
          return false;
        }
        const isLt5M = file.size / 1024 / 1024 < 10
        if (!isLt5M) {
          this.$message.error('图片大小不能超过 10MB!')
        }else{
          this.uploadLoading = true
        }
        return isLt5M
      },
      uploadImg (item) {
        var _this = this
        const formData = new FormData() // 创建form对象
        formData.append('file', item.file)// 通过append向form对象添加数据
        formData.append('uid', item.file.uid)// 通过append向form对象添加数据

        let reader = new FileReader();
        let imgFile
        // let that = this
        reader.readAsDataURL(item.file)
        reader.onload = e => {
          imgFile = e.target.result;
          let arr = imgFile.split(',')
          _this.textarea="data:image/png;base64,"+arr[1];
          _this.sendMessage();
          _this.uploadLoading = false
        }
      },
      //显示上传图片弹窗
      showUploadImg () {
        if(this.receiveUserId==null||this.receiveUserId==undefined){
          this.$message.error("请选择消息发送人")
          return false;
        }
        this.createAppPoster()

      },
      //隐藏上传图片弹窗
      hideUploadImg () {
        this.dialogUploadImg = false
      },
      handleEmotion (i) {
        this.textarea += i
      },
      // 将匹配结果替换表情图片
      emotion (res) {
        let word = res.replace(/\#|\;/gi,'')
        const list = ['微笑', '撇嘴', '色', '发呆', '得意', '流泪', '害羞', '闭嘴', '睡', '大哭', '尴尬', '发怒', '调皮', '呲牙', '惊讶', '难过', '酷', '冷汗', '抓狂', '吐', '偷笑', '可爱', '白眼', '傲慢', '饥饿', '困', '惊恐', '流汗', '憨笑', '大兵', '奋斗', '咒骂', '疑问', '嘘', '晕', '折磨', '衰', '骷髅', '敲打', '再见', '擦汗', '抠鼻', '鼓掌', '糗大了', '坏笑', '左哼哼', '右哼哼', '哈欠', '鄙视', '委屈', '快哭了', '阴险', '亲亲', '吓', '可怜', '菜刀', '西瓜', '啤酒', '篮球', '乒乓', '咖啡', '饭', '猪头', '玫瑰', '凋谢', '示爱', '爱心', '心碎', '蛋糕', '闪电', '炸弹', '刀', '足球', '瓢虫', '便便', '月亮', '太阳', '礼物', '拥抱', '强', '弱', '握手', '胜利', '抱拳', '勾引', '拳头', '差劲', '爱你', 'NO', 'OK', '爱情', '飞吻', '跳跳', '发抖', '怄火', '转圈', '磕头', '回头', '跳绳', '挥手', '激动', '街舞', '献吻', '左太极', '右太极']
        let index = list.indexOf(word)
        return `<img class="emoji" src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/${index}.gif">`
      },
      showVideoEvent () {
        this.showVideo = true
      },
      hideVideoEvent () {
        this.showVideo = false
      },
      handelUserState (command) {
          this.user.status=command;
          this.$socket.emit('changeOnlineUserStatus',this.user)
        this.userState = Number(command)
      },
      setTop(command){
        let that = this;
        let user={
          userid:this.currentUserId,
          receiveid:this.receiveUserId,
          receivename:this.receiveUserInfo.userName
        }
        if(command==2){//拉黑
          this.$confirm("确定拉黑此用户？","提示",{
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$socket.emit('clearchatlog',user)
            let url="/rrbi/friends/black/"+this.receiveUserId+"?tem="+new Date().getMilliseconds()
            that.$axios.get(url).then(function (result) {
              that.$message.success('拉黑成功')
            })
          }).catch(() => {
            console.log("quxiao")
          });
        }else{
          let val=command==1?0:1
          this.$socket.emit('setTop',user,val)
          this.istop=val;
        }
      },
      stopUploadVideo () {
        let this_ = this
        //clearTimeout(tm)
        if(this_.form.videoCcId && this_.form.videoCcId.length > 5){
          utilAPi.videoDelete(this_.form.videoCcId).then(() => {
            this_.form.videoCcId=''
            this_.form.videoCcName=''
            this_.dialogUploadVideo = false
            this_.processLenghth=0
          })
        }
      },
      closeVideoDialog(){
        let processLenghth = this.processLenghth
        $('.pauseObj').attr('style', '');
        $('.resumeObj').attr('style', 'display:none');
        if(processLenghth==100){
          //this.finishedUploadVideo()
        }else{
          this.stopUploadVideo()
        }
      },
      //完成上传
      finishedUploadVideo () {
        let this_ =this
        let mes='<iframe id="cciframe_'+this_.form.videoCcId+'" src="https://p.bokecc.com/playhtml.bo?vid='+this_.form.videoCcId+'&siteid=9D23FB9C216EB7C0&autoStart=false&isshare=false&playerid=AB4A28055BBF9E34&playertype=1&newversion=true" allowfullscreen="true" frameborder="0" height="200" width="90%"></iframe>';
        this_.textarea=mes;
        this_.sendMessage();
        this.dialogUploadVideo = false
      },
      closeCCUploadChunk(){
        var url = this.uploadchunk
        var jqXhr = $.getJSON(url,{},function(){});
        jqXhr.abort()

      },
      createAppPoster() {
        let _this=this;
        // 生成海报
        const vm = this
        const domObj = document.getElementById('htmlArea')
        // domObj = domObj.replace("ocs.21teacher.com","www.renrendonghua.com")
        _this.html2canvas(domObj, {
          useCORS: true,
          allowTaint: false,
          logging: false,
          letterRendering: true,
          onclone(doc) {
            let e = doc.querySelector('#htmlArea')
            e.style.display = 'block'
          }
        }).then(function(canvas) {
          _this.$nextTick(()=>{

            _this.imgOption.img= canvas.toDataURL('image/png')
            _this.dialogUploadImg = true
          });

        }).catch(() => {
          console.log("出错了")
        });
      },
      cutOver () {

        let _this = this
        _this.dialogUploadImg = false
        _this.uploadLoading = true
        // // 输出bolb格式地址
        _this.$refs.cropper.getCropData((data) => {
          _this.textarea=data;
          _this.sendMessage();
          _this.uploadLoading = false

        })

      },
        beforeFileUpload (file) {
          this.fileInfo=null;
          if(this.receiveUserId==null||this.receiveUserId==undefined){
            this.$message.error("请选择消息发送人")
            return false;
          }
            const isLt1024M = file.size / 1024 / 1024 < 500
            if (!isLt1024M) {
                this.$message.error('文件大小不能超过 500M!')
                return false;
            }
            return isLt1024M
        },
      cancelUploadFile(){
        this.showProgress = false
        client().cancel();
      },
      uploadFile(file){
              const that = this;

        that.uploadFilename=file.file.name
              async function multipartUpload() {
                  let temporary = file.file.name.lastIndexOf(".");
                  let fileNameLength = file.file.name.length;
                  let fileFormat = file.file.name.substring(
                      temporary + 1,
                      fileNameLength
                  );
                  let fileName = getFileNameUUID() + "." + fileFormat;
                  client().multipartUpload(`dir-document/${fileName}`, file.file, {
                          progress: function(p) {
                              //p进度条的值
                              that.showProgress = true;
                              that.progress = Math.floor(p * 100);
                          }
                      })
                      .then(result => {

                        let filesize=parseFloat(Number(file.file.size)/1048576).toFixed(2)+"M"
                        let fileInfo={
                          filesizeM:filesize,
                          originalFileName:file.file.name,
                          url:"http://oel-cloud-storage.oss-cn-beijing.aliyuncs.com/"+result.name,
                        }
                        that.fileInfo=fileInfo
                      })
                      .catch(err => {
                          console.log("err:", err);
                      });
              }
              multipartUpload();
      },
      finishedUploadFile() {
        let this_ =this
        this_.textarea=qs.stringify(this.fileInfo);
        this_.sendMessage();
        this.showProgress = false
      },
      handleSuccess(){
          console.log("上传成功===================")
      }
    }
  }
</script>

<style scoped lang="less">
  @import "../../assets/less/edit.less";
  .page-chatroom{
    #fileupload{
      input[type='file']{
        display: none;
      }
      .upload-btn{
        display: inline-block;
        box-sizing: border-box;
        margin: 0;
        padding: 9px 15px;
        line-height: 1;
        text-align: center;
        color: #FFF;
        font-size: 12px;
        font-weight: 500;
        white-space: nowrap;
        background: #FFF;
        border: 1px solid #DCDFE6;
        -webkit-appearance: none;
        background-color: #409EFF;
        border-color: #409EFF;
        border-radius: 3px;
        transition: .1s;
        cursor: pointer;
        outline: 0;
        &:hover,
        &:focus{
          background: #66b1ff;
          border-color: #66b1ff;
          color: #FFF;
        }
        &:active{
          background: #3a8ee6;
          border-color: #3a8ee6;
          color: #FFF;
        }
      }}
    padding-top: @NAVHEIGHT + 50;
    padding-bottom: 50px;
    background: #fff;
    .chat-wrap{
      overflow: hidden;
      margin: 0 auto;
      width: 950px;
      height: 760px;
      border-radius: 5px;
      .chat-head{
        overflow: hidden;
        height: 60px;
        background: #19181d;
        .side-r{
          float: right;
          .firend-info{
            float: left;
            display: block;
            margin-top: 8px;
            height: 44px;
            .avatar{
              float: left;
              width: 44px;
              height: 44px;
              background-size: cover;
              border-radius: 4px;
              cursor: pointer;
              &.point{
                position: relative;
                &:after{
                  position: absolute;
                  right: -6px;
                  top: -6px;
                  content: '';
                  display: block;
                  width: 12px;
                  height: 12px;
                  border-radius: 50%;
                }
                &.online:after{
                  background: #41d629;
                }
                &.offline:after{
                  background: #b2b7b9;
                }
                &.busy:after{
                  background: #ee4a58;
                }
              }
            }
            .name{
              float: left;
              padding: 0 10px;
              margin-top: 10px;
              color: #d5d5d5;
              font-size: 18px;
              line-height: 24px;
            }
          }
          .serve-state{
            float: left;
            margin-right: 10px;
            margin-top: 15px;
            height: 30px;
            line-height: 30px;
            color: #fff;
            cursor: pointer;
          }
          .shu{
            float: left;
            margin-top: 17px;
            width: 1px;
            height: 26px;
            background: #fff;
          }
          .setting{
            margin: 18px 25px 0;
            float: left;
            color: #d5d5d5;
            font-size: 20px;
            line-height: 24px;
          }
        }
      }
      .list-chat{
        .left-list{
          overflow-y: auto;
          float: left;
          width: 251px;
          height: 700px;
          background: #fcfcfc;
          border-right: 1px solid #e2e2e2;
          .firend-item{
            position: relative;
            padding: 10px;
            border-bottom: 1px solid #e8e8e8;
            cursor: pointer;
            &.active,
            &:hover{
              background: #f3f3f3;
            }
            .info-chat-one{
              .avatar{
                float: left;
                width: 44px;
                height: 44px;
                background-size: cover;
                border-radius: 4px;
              }
              .chat-one{
                float: left;
                margin-left: 10px;
                .name{
                  display: block;
                  color: #19181d;
                  font-size: 18px;
                  line-height: 26px;
                }
                .one{
                  display: block;
                  color: #b5b5b5;
                  font-size: 14px;
                  line-height: 18px;
                }
                .over{
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  display: block;
                  width: 130px;
                }
              }
            }
            .time{
              position: absolute;
              right: 10px;
              top: 10px;
              font-size: 12px;
            }
          }
        }
        .right-chat{
          float: right;
          width: 699px;
          height: 700px;
          background: #f3f3f3;
          .show-infoo{
            padding: 0 10px;
            height: 30px;
            line-height: 30px;
            font-size: 14px;
            background: #e4e4e4;
            .his-name{
              float: left;
            }
            .cz-his{
              float: right;
              cursor: pointer;
            }
          }
          .chizi{
            overflow: auto;
            padding: 20px;
            width: 100%;
            height: 482px;
            .other,
            .myself{
              margin-bottom: 10px;
              .avatar{
                float: left;
                width: 44px;
                height: 44px;
                background-size: cover;
                border-radius: 4px;
              }
              .words{
                position: relative;
                float: left;
                padding: 10px;
                margin-left: 10px;
                margin-top: 2px;
                max-width: calc(100% - 55px);
                line-height: 20px;
                font-size: 14px;
                color: #000;
                background: #fff;
                border-radius: 4px;
                /deep/img.emoji{
                  display: inline;
                  vertical-align: text-bottom;
                }
                &:before{
                  position: absolute;
                  top: 15px;
                  content: '';
                  display: block;
                  width: 0;
                  height: 0;
                  border-width: 5px;
                  border-style: solid;
                }
                &.type-img{
                  padding: 5px;
                  cursor: pointer;
                  /deep/img{
                    width: 200px;
                    height: auto;
                  }
                }
                &.type-video{
                  position: relative;
                  padding: 5px;
                  cursor: pointer;
                  img{
                    width: 200px;
                  }
                  .play-icon{
                    position: absolute;
                    right: 5px;
                    bottom: 5px;
                    top: 5px;
                    left: 5px;
                    background-color: rgba(0,0,0,.3);
                    background-image: url('../../assets/images/video_play_icon.png');
                    background-repeat: no-repeat;
                    background-position: center;
                  }
                }
                &.type-file{
                  display: flex;
                  max-width: 200px;
                  background: #fff;
                  cursor: pointer;
                  &:before{
                    border-left-color: #fff;
                  }
                  .left-type-icon{
                    margin-right: 5px;
                    flex: 0 0 38px;
                    width: 38px;
                  }
                  .file-info{
                    overflow: hidden;
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    .tit{
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                      color: #000;
                      font-size: 14px;
                    }
                    .size{
                      color: #8b8b8b;
                      font-size: 12px;
                    }
                  }
                }
              }
            }
            .myself{
              .avatar,
              .words{
                float: right;
                background: #95ec69;
              }
              .words{
                margin-left: 0;
                margin-right: 10px;
              }
              .avatar{
                background-size: cover;
              }
            }
            .other{
              .words{
                &:before{
                  left: -10px;
                  border-color: transparent #fff transparent transparent;
                }
              }
            }
            .myself{
              .words{
                &:before{
                  right: -10px;
                  border-color: transparent transparent transparent #95ec69;
                }
              }
            }
            .show-time{
              margin-bottom: 10px;
              text-align: center;
              span{
                display: inline-block;
                padding: 5px;
                color: #fff;
                font-size: 12px;
                background: #dadada;
              }
            }
            .add-more,
            .no-more{
              margin: 5px 0;
              text-align: center;
              color: #4e90ff;
              font-size: 12px;
            }
            .add-more{
              cursor: pointer;
            }
          }
          .cons{
            padding: 15px;
            width: 100%;
            height: 188px;
            border-top: 1px solid #e2e2e2;
            .btns{
              .btn-item{
                float: left;
                margin-right: 20px;
                i{
                  display: block;
                  width: 22px;
                  height: 22px;
                  background-size: 100%;
                  cursor: pointer;
                  &.bq{
                    background-image: url('../../assets/images/icon_chat01.png')
                  }
                  &.wj{
                    background-image: url('../../assets/images/icon_chat02.png')
                  }
                  &.tp{
                    background-image: url('../../assets/images/icon_chat03.png')
                  }
                  &.sp{
                    background-image: url('../../assets/images/icon_chat04.png')
                  }
                  &.jp{
                    background-image: url('../../assets/images/icon_chat05.png')
                  }
                }
                &.bq-item{
                  position: relative;
                  &:hover{
                    .emoji-wrap{
                      display: block;
                    }
                  }
                  .emoji-wrap{
                    // overflow-y: auto;
                    display: none;
                    position: absolute;
                    top: -200px;
                    left: -50px;
                    width: 500px;
                    height: 200px;
                    .emoji-list{
                      width: 100%;
                      background: #fff;
                      border: 1px solid #e2e2e2;
                      border-radius: 5px;
                    }
                  }
                }
                .label{
                  .ipt{
                    display: none;
                  }
                }
                /deep/.el-upload-list{
                  display: none !important;
                }
              }
            }
            .myself-input{
              margin-top: 10px;
              height: 90px;
              /deep/.el-textarea{
                textarea{
                  height: 90px;
                  background: none;
                  border: none;
                }
              }
            }
            .send-btn{
              margin-top: 6px;
              .btn{
                float: right;
                width: 80px;
                height: 30px;
                line-height: 30px;
                text-align: center;
                color: #575757;
                font-size: 14px;
                background: #e2e2e2;
                border-radius: 4px;
                cursor: pointer;
                &.active{
                  color: #000;
                  background: #95ec69;
                  transition: all .3s;
                }
              }
            }
          }
        }
      }
    }
    .show-video{
      position: fixed;
      z-index: 5555;
      left: 0;top: 0;
      right: 0;bottom: 0;
      background: rgba(0,0,0,.3);
      .mask,
      .video-wrap{
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
      }
      .video-wrap{
        display: flex;
        justify-content: center;
        align-items: center;
        .v-video{
          width: 800px;
        }
      }
      .close-video-show{
        overflow: hidden;
        position: absolute;
        right: -40px;
        top: -40px;
        width: 80px;
        height: 80px;
        background-color: rgba(0,0,0,.3);
        border-radius: 50%;
        cursor: pointer;
        i{
          position: absolute;
          bottom: 15px;
          left: 15px;
          color: #fff;
        }
      }
    }
    .sta-point{
      width: 12px;
      height: 12px;
      line-height: 12px;
      border-radius: 50%;
      &.online{
        background: #41d629;
      }
      &.offline{
        background: #b2b7b9;
      }
      &.busy{
        background: #ee4a58;
      }
      &:before{
        opacity: 0;
      }
    }
  }
  @media screen and (max-width: 950px) {
    .page-chatroom{
      padding: 0;
      padding-top: @NAVHEIGHT;
      .chat-wrap{
        width: 100%;
        height: calc(100vh - @NAVHEIGHT - 50px);
        .chat-head{
          display: none;
        }
        .list-chat{
          display: flex;
          width: 100%;
          height: 100%;
          .left-list{
            overflow: hidden;
            overflow-y: auto;
            flex: 0 0 50px;
            width: 50px;
            height: 100%;
            .firend-item{
              padding: 0;
              width: 50px;
              height: 50px;
              .info-chat-one{
                .avatar{
                  margin: 5px 0 0 5px;
                  width: 40px;
                  height: 40px;
                  border-radius: 50%;
                }
                .chat-one{
                  display: none;
                }
              }
              .time{
                display: none;
              }
            }
          }
          .right-chat{
            flex: 1;
            height: 100%;
            .chizi{
              height: calc(100% - 180px);
            }
            .cons{
              padding: 10px;
              height: 150px;
              .btns{
                .bq-item{
                  .emoji-wrap{
                    left: 0 !important;
                    width: calc(100vw - 80px) !important;
                  }
                }
              }
              .myself-input{
                height: 62px;
                /deep/.el-textarea{
                  textarea{
                    height: 62px;
                  }
                }
              }
            }
          }
        }
      }
    }
    .show-video{
      .video-wrap{
        background: #000;
        .v-video{
          width: 95%;
        }
      }
    }
  }
  .renren-video-player{
    &.vjs-custom-skin{
      & > .video-js .vjs-play-progress:before{
        top: -0.4em;
      }
    }
    /deep/.vjs-big-play-button{
      background: rgba(0, 0, 0, 0.45) !important;
      &:active{
        background: none;
      }
      .vjs-icon-placeholder{
        font-size: 1.3em;
        color: #fff;
      }
    }
    .vjs-control-bar{
      *{
        color: #fff;
      }
    }
  }
</style>
